import React, { Component } from "react";

const BookingSummary = ({ color, text, label, textSize }) => {
  return (
    <div className="booking-summary-branch">
      <strong className="sameHeads sameTextColor" style={{ color: color }}>
        {label}
      </strong>
      <p className="sameFont" style={{ fontSize: textSize }}>
        {text}
      </p>
    </div>
  );
};

export default BookingSummary;
